/* eslint-disable no-plusplus */
import PlayerFactory from '../models/PlayerFactory';
import WindowsMediaPlayer from './WindowsMediaPlayer';

/**
 * Windows Media Player ActiveX control ID.
 *
 * Documentation:
 *  https://docs.microsoft.com/en-us/windows/win32/wmp/simple-example-of-scripting-in-a-web-page#adding-the-object-tag
 *
 * @type {string}
 */
const WindowsMediaPlayerClassId = 'clsid:6BF52A52-394A-11d3-B153-00C04F79FAA6';

export default class WindowsMediaPlayerFactory extends PlayerFactory {
  constructor(blankMP3Url) {
    super();
    this.blankMP3Url = blankMP3Url;
    this.playerInstanceCount = 0;
  }

  createPlayer() {
    const wmpPlayerId = 'wmp_player_' + this.playerInstanceCount;
    this.playerInstanceCount++;
    const containerElement = document.createElement('div');
    const objectElement = document.createElement('object');

    objectElement.setAttribute('id', wmpPlayerId);
    objectElement.setAttribute('width', '0');
    objectElement.setAttribute('height', '0');
    objectElement.setAttribute('classId', WindowsMediaPlayerClassId);

    containerElement.appendChild(objectElement);
    document.body.appendChild(containerElement);

    return new WindowsMediaPlayer(
      wmpPlayerId,
      containerElement,
      this.blankMP3Url,
    );
  }
}
